import * as React from 'react';
import { translation } from 'easit--localization';
import { ProgressStateModel, OfferType } from 'eTip--common';

import { ButtonPrimary, InfoBox, ProgressContent, TicketDetailSelections, TicketSummary } from 'common--design-library';
import { IMobileTicketDetailProps } from 'mobile--design-library';

import { Actions } from './actions';
import { translationForMts } from 'easit--localization';

export interface IDesktopTicketDetailProps extends IMobileTicketDetailProps {
    title: string;
    offerType: OfferType;
    goBack: () => void;
    refresh: () => void;
    insertPublicLinkToChat: () => void | null;
    isOTB: boolean;
}

export const TicketDetail: React.FC<IDesktopTicketDetailProps> = (props) => {

    const renderOperationMessage = (state: ProgressStateModel, message: string, canUseInfoIconForSuccess: boolean) => {

        if (state === ProgressStateModel.Success) {
            // return <div className="alert cashout-success"><SubmitMessageIcon className="fa fa-check accepted" /> {message}</div>
            return <div className="d-flex align-items-center" >
                <InfoBox type={canUseInfoIconForSuccess ? 'info' : 'success'} messages={{ text: message, withIcon: true }} />
            </div>
        }

        return state === ProgressStateModel.Failed
            && message
            && <div className="d-flex align-items-center" >
                <InfoBox type='error' messages={{ text: message, withIcon: true }} />
            </div>
    }

    const t = translationForMts();

    return <><div className="ticket-detail">
        <div className={"d-flex justify-content-between w-100"}>
            <h1 className="p-1" data-test-role="ticket-detail--header">{props.title}</h1>
            {<Actions back={props.goBack} refresh={props.refresh} />}
        </div>
        {
            props.isNotLegacy ?
                <div className="w-100 detail-panels-wrapper">
                    <div className="detail-panel summary-panel float-left">
                        {props.state == ProgressStateModel.Success && props.cashOut}
                        <div className="w-100">
                            <ProgressContent state={props.state} errorMessage={props.error} inline={true} className="p-2">
                                {<TicketSummary
                                    {...props}
                                    showHeader={true}
                                    offerTypeAsText={props.offerType === OfferType.Prematch ? t.coupon_TypePrematch : t.coupon_TypeLive}
                                />}
                            </ProgressContent>

                            <div className="mt-2 buttons-wrapper">
                                {props.canShowCancelButton &&
                                    <div>
                                        <ButtonPrimary className={__IsMTSTipos__ ? null : "ml-2"} onClick={props.onCancel}>{t.bet_CancelBetBtnCancelTitle} {props.cancelState === ProgressStateModel.Loading ? <span className="fas fa-spinner fa-spin"></span> : null}</ButtonPrimary>
                                    </div>
                                }
                                {
                                    renderOperationMessage(props.cancelState, props.cancelMessage, false)
                                }

                                {props.state == ProgressStateModel.Success && props.canShowReuseOddsButton && !props.isOTB &&
                                    <div>
                                        <ButtonPrimary className={__IsMTSTipos__ ? null : "ml-2"} onClick={props.onReuseOdds}>{t.ticket_ReuseOddsTicketBtn} {props.reuseOddsState === ProgressStateModel.Loading ? <span className="fas fa-spinner fa-spin"></span> : null}</ButtonPrimary>
                                    </div>
                                }
                                {
                                    props.reuseOddsMessage && renderOperationMessage(props.reuseOddsState, props.reuseOddsMessage, true)
                                }
                            </div>
                        </div>
                    </div>
                    <div className="detail-panel selections-panel float-right">
                        <TicketDetailSelections
                            selections={props.selections}
                            isSystem={props.isSystem}
                            canShowNewFeatureScore={props.canShowNewFeatureScore}
                            canShowFinalScoreInfo={props.canShowFinalScoreInfo}
                            goToEvent={props.onGoToEvent}
                        />
                    </div>
                    <div className="detail-panel combinations-panel float-left">
                        {props.combinations}
                        {
                            props.publicTicketLink &&
                            <div className="p-2">
                                {translation().ticket_public_link}
                                <a className="ml-2 public-link" href={props.publicTicketLink} target="_blank">{props.publicTicketLink}</a>
                            </div>
                        }
                        {
                            props.state === ProgressStateModel.Success && props.insertPublicLinkToChat && <a href="" className="mx-2 public-link cursor-pointer" onClick={(evt) => { /*href due to style */
                                evt.preventDefault();
                                evt.stopPropagation();
                                props.insertPublicLinkToChat();
                            }} >{translation().coupon_AddPublicLinkToChat}</a>
                        }
                    </div>
                </div>
                :
                <>
                    {
                        props.state === ProgressStateModel.Success ?
                            <div className="w-100" dangerouslySetInnerHTML={{ __html: props.legacyContent }}></div>
                            :
                            <div className="w-100"><ProgressContent state={props.state} errorMessage={props.error}></ProgressContent></div>
                    }
                </>
        }
    </div>
    </>
}